/**
 *
 * Students
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-bootstrap';
import useVideoEnabled from 'components/VideoConf/useVideoEnabled.js';
import { focusFirstInput } from 'utils/formHelpers.js';
import messages from './messages.js';
import EditModal from './EditModal/index.jsx';
import ActionButtons from '../ActionButtons/index.jsx';
import useSelectStudents from './useSelectStudents.js';
import StudentRow from './StudentRow.jsx';

function Students(props) {
  const { meetingSet, onClose, onNext } = props;
  const { meetingLocationType } = meetingSet;
  const [editId, setEditId] = useState(); // studentMeetingId for which editModal is shown
  const [selectId, setSelectId] = useState(null);
  const [enabled] = useVideoEnabled();

  const { state, handleChange, handleIgnore, handleCheck, handleSelectType, allChecked, handleSave } = useSelectStudents(meetingSet);
  useEffect(() => {
    focusFirstInput();
    return () => handleSave(false, messages.savePrompt);
  }, []);

  function handleClose(flag) {
    if (flag) {
      handleSave();
    } else {
      handleIgnore();
    }
    onClose();
  }

  async function handleSubmit() {
    await handleSave();
    onNext();
  }

  return (
    <>
      <table className="table table-condensed">
        <thead>
          <tr className="small">
            <th className="text-nowrap" width="40%">
              <Form.Check type="checkbox" checked={allChecked} onChange={(ev) => handleCheck(0, ev.target.checked)} label={<FormattedMessage {...messages.select} />} />
            </th>
            {enabled && (
              <th width="20%">
                <FormattedMessage {...messages.meetingLocationType} />
              </th>
            )}
            <th className="text-end" colSpan="2" width="40%">
              <FormattedMessage {...messages.options} />
            </th>
          </tr>
        </thead>
        <tbody>
          {meetingSet.students.list.map((studentId) => (
            <StudentRow
              key={studentId}
              studentState={state[studentId]}
              defaultMeetingLocationType={meetingLocationType}
              onEdit={() => setEditId(studentId)}
              onCheck={(value) => handleCheck(studentId, value)}
              onOpenSelect={(meetingId) => setSelectId(meetingId ? { studentId, meetingId } : null)}
              onSelectType={(meetingId, value) => handleSelectType(studentId, meetingId, value)}
              selectTypeId={selectId && selectId.studentId === studentId ? selectId.meetingId : 0}
            />
          ))}
        </tbody>
      </table>
      <div className="mb-3">
        <ActionButtons onSubmit={handleSubmit} onCancel={onClose} onClose={handleClose} />
      </div>
      {Boolean(editId) && (
        <EditModal
          show
          onHide={() => setEditId(0)}
          value={state[editId]}
          onChange={(value) => handleChange(editId, value)}
        />
      )}
    </>
  );
}

Students.propTypes = {
  meetingSet: PropTypes.object,
  onNext: PropTypes.func,
  onClose: PropTypes.func,
};

export default Students;
